import { defineStore } from 'pinia'
import { ExemptedPaths } from '~/model/ExemptedPath'

export const useUserStore = defineStore({
    id: 'user',
    state: () => ({
        user: null,
        xeroInfo: null,
    }),
    actions: {
        async fetchUser() {
            if (this.user == null) {
                try {
                    this.user = await this.$nuxt.$axios.$get('/api/me')
                } catch (error) {
                    if (error.response.status === 404) {
                        this.user = null
                        if (this.$nuxt.route.path !== ExemptedPaths.LOGIN) {
                            this.$nuxt.redirect('/login')
                        }
                    }
                }
            }
            return this.user
        },
        async fetchXeroInfo(refresh = false) {
            if (this.xeroInfo == null || refresh) {
                this.xeroInfo = await this.$nuxt.$axios.$get('/api/xero/info', { progress: false })
            }
            return this.xeroInfo
        },
        hasScope(scope) {
            return !this.xeroInfo.missingScopes.includes(scope)
        },
    },
})
